// extracted by mini-css-extract-plugin
export default {"root":"hcx-card-header_root__7-A6q","switcher":"hcx-card-header_switcher__DZ0nA"};